import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableTemplateLibrary = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableTemplateLibrary);
};
